"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBool = exports.when = exports.toTask = exports.toResult = void 0;
var maybeasy_1 = require("maybeasy");
var resulty_1 = require("resulty");
var taskarian_1 = require("taskarian");
function toResult(e, thing) {
    return thing
        ? thing.map(resulty_1.ok).getOrElse(function () { return resulty_1.err(e); })
        : function (thing) { return thing.map(resulty_1.ok).getOrElse(function () { return resulty_1.err(e); }); };
}
exports.toResult = toResult;
function toTask(e, thing) {
    var doit = function (thing) {
        return thing.map(taskarian_1.default.succeed).getOrElse(function () { return taskarian_1.default.fail(e); });
    };
    return typeof thing === 'undefined' ? doit : doit(thing);
}
exports.toTask = toTask;
function when(predicate, result) {
    var doit = function (result) {
        var test = typeof predicate === 'boolean' ? predicate : predicate(result);
        return test ? maybeasy_1.just(result) : maybeasy_1.nothing();
    };
    return typeof result === 'undefined' ? doit : doit(result);
}
exports.when = when;
exports.fromBool = when;
